import { AppGridLayout } from 'api'
import React, { Component, RefObject } from 'react'
import './AppGridLayout.less'

export interface AppGridLayoutContext extends AppGridLayout {
	viewId: any
	chgView: (viewId: number) => void
	viewHeight: string
	refAppGridHeard: RefObject<HTMLDivElement>
	refAppGridView: RefObject<HTMLDivElement>
	calViewHeight: (appGridSearchHeight: number) => void
}
export const AppGridLayoutContext = React.createContext<AppGridLayoutContext>({} as AppGridLayoutContext)

export interface AppGridLayoutProps extends AppGridLayout {
	style?: React.CSSProperties
}

export default class extends Component<AppGridLayoutProps> {
	state = {
		viewId: this.props.defaultViewId || -1,
		viewHeight: `calc(100% - ${
			(this.props.appGridHeard &&
				this.props.appGridHeard.appGridMenu &&
				this.props.appGridHeard.appGridMenu.appActionList) ||
			this.props.appGridViewList.length > 1
				? 45
				: 0
		}px)`,
	}

	chgView = (viewId: any) => {
		this.setState({
			viewId,
			viewHeight:
				(this.refAppGridView && this.refAppGridView.current && this.refAppGridView.current.style.height) ||
				this.state.viewHeight,
		})
	}

	calViewHeight = (appGridSearchHeight: number) => {
		// alert(`calc(100% - ${this.refAppGridHeard.current.offsetHeight + this.refAppGridSearch.current.offsetHeight})px`)
		if (this.refAppGridView && this.refAppGridView.current)
			this.refAppGridView.current.style.height = `calc(100% - ${((this.refAppGridHeard.current &&
				this.refAppGridHeard.current.offsetHeight) ||
				0) + (appGridSearchHeight || 0)}px)`
	}

	refAppGridHeard = React.createRef<HTMLDivElement>()
	refAppGridView = React.createRef<HTMLDivElement>()
	render() {
		return (
			<AppGridLayoutContext.Provider
				value={{
					...(this.props as AppGridLayout),
					viewId: this.state.viewId,
					chgView: this.chgView,
					viewHeight: this.state.viewHeight,
					refAppGridHeard: this.refAppGridHeard,
					refAppGridView: this.refAppGridView,
					calViewHeight: this.calViewHeight,
				}}
			>
				<div className="app-grid-layout" style={this.props.style}>
					{this.props.children}
				</div>
			</AppGridLayoutContext.Provider>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/AppGridLayout/AppGridLayout.tsx